import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import moment from 'utils/cops-moment';
import * as actionTypes from './message-center-constants';

export const messages = handleActions(
  {
    [actionTypes.ACTION_REQUIRED_MESSAGES_REQUEST]: state => state,
    [actionTypes.ACTION_REQUIRED_MESSAGES_SUCCESS]: (state, { payload }) => payload,
    [actionTypes.ACTION_UPDATED_MESSAGES_SUCCESS]: (state, { payload }) => {
      const newItems = payload.filter(p => !state.find(m => m.correlationId === p.correlationId));
      const updatedItems = state?.map((m) => {
        if (payload?.find(p => p.correlationId === m.correlationId)) {
          return payload.find(p => p.correlationId === m.correlationId);
        }
        return m;
      });
      return [...newItems, ...updatedItems].sort((a, b) => {
        const dateA = moment(a.operationDate);
        const dateB = moment(b.operationDate);
        if (dateA.isBefore(dateB)) {
          return 1;
        } else if (dateA.isAfter(dateB)) {
          return -1;
        }
        return 0;
      });
    },
    [actionTypes.DELETE_MESSAGES]: (state, { payload }) => state.filter(s =>
      !payload?.correlationIds?.includes(s.correlationId),
    ),
  },
  [],
);

export const messageCount = handleActions(
  {
    [actionTypes.ACTION_REQUIRED_MESSAGES_SUCCESS]: (state, { payload }) => payload.length,
    [actionTypes.ACTION_REQUIRED_COUNT_SUCCESS]: (state, { payload }) => payload.messageCount,
    [actionTypes.DELETE_MESSAGES]: (state, { payload }) =>
      state - payload?.correlationIds?.length < 0 ? 0 : state - payload?.correlationIds?.length,
  },
  0,
);

export const history = handleActions(
  {
    [actionTypes.HISTORY_REQUEST]: () => [],
    [actionTypes.HISTORY_SUCCESS]: (state, { payload }) => payload.items,
    [actionTypes.GET_HISTORY_DATA_NEXT_SUCCESS]: (state, { payload }) => [
      ...state,
      ...payload.items,
    ],
  },
  [],
);

export const isLoadingHistory = handleActions(
  {
    [combineActions(actionTypes.HISTORY_FAILURE, actionTypes.HISTORY_SUCCESS)]: () => false,
    [actionTypes.HISTORY_REQUEST]: () => true,
  },
  false,
);

export const isLoadingMessages = handleActions(
  {
    [combineActions(
      actionTypes.ACTION_REQUIRED_MESSAGES_FAILURE,
      actionTypes.ACTION_REQUIRED_MESSAGES_SUCCESS,
    )]: () => false,
    [actionTypes.ACTION_REQUIRED_MESSAGES_REQUEST]: () => true,
  },
  false,
);

export const isDismissing = handleActions(
  {
    [combineActions(
      actionTypes.DISMISS_FAILURE,
      actionTypes.DISMISS_SUCCESS,
      actionTypes.DISMISS_ALL_FAILURE,
      actionTypes.DISMISS_ALL_SUCCESS,
    )]: () => false,
    [combineActions(actionTypes.DISMISS_REQUEST, actionTypes.DISMISS_ALL_REQUEST)]: () => true,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ACTION_REQUIRED_MESSAGES_REQUEST,
      actionTypes.ACTION_REQUIRED_MESSAGES_SUCCESS,
      actionTypes.HISTORY_REQUEST,
      actionTypes.HISTORY_SUCCESS,
      actionTypes.DISMISS_SUCCESS,
      actionTypes.DISMISS_REQUEST,
      actionTypes.DISMISS_ALL_SUCCESS,
      actionTypes.DISMISS_ALL_REQUEST,
      actionTypes.GET_HISTORY_DATA_NEXT_SUCCESS,
      actionTypes.GET_HISTORY_DATA_NEXT_REQUEST,
    )]: () => ({}),
    [combineActions(
      actionTypes.ACTION_REQUIRED_MESSAGES_FAILURE,
      actionTypes.HISTORY_FAILURE,
      actionTypes.DISMISS_FAILURE,
      actionTypes.DISMISS_ALL_FAILURE,
      actionTypes.GET_HISTORY_DATA_NEXT_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const isNextHistoryDataLoading = handleActions(
  {
    [combineActions(
      actionTypes.GET_HISTORY_DATA_NEXT_FAILURE,
      actionTypes.GET_HISTORY_DATA_NEXT_SUCCESS,
    )]: () => false,
    [actionTypes.GET_HISTORY_DATA_NEXT_REQUEST]: () => true,
  },
  false,
);

export const hasNextHistoryData = handleActions(
  {
    [combineActions(
      actionTypes.GET_HISTORY_DATA_NEXT_FAILURE,
      actionTypes.GET_HISTORY_DATA_NEXT_REQUEST,
    )]: () => false,
    [actionTypes.GET_HISTORY_DATA_NEXT_SUCCESS]: (state, { payload }) => payload.items.length > 0,
    [actionTypes.HISTORY_REQUEST]: () => true,
  },
  true,
);

export const pollingDelay = handleActions(
  {
    [actionTypes.SET_FAST_POLLING_REQUEST]: () => 15000,
    [combineActions(
      actionTypes.SET_SLOW_POLLING_REQUEST,
      actionTypes.START_POLLING,
    )]: () => 300000,
  },
  0,
);

export const totalCount = handleActions(
  {
    [actionTypes.HISTORY_SUCCESS]: (state, { payload }) => payload.totalCount,
  },
  0,
);

export default combineReducers({
  messages,
  history,
  isLoadingHistory,
  error,
  isDismissing,
  isNextHistoryDataLoading,
  hasNextHistoryData,
  pollingDelay,
  totalCount,
  messageCount,
  isLoadingMessages,
});
